import { render, staticRenderFns } from "./componentCGVDistri.vue?vue&type=template&id=29445dd9"
import script from "./componentCGVDistri.vue?vue&type=script&lang=js"
export * from "./componentCGVDistri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports